import * as tslib_1 from "tslib";
import { Attr, Field, Selector } from '@swim/recon';
import { DirectiveForm } from './directive-form';
import { InjectDirective } from './inject-directive';
var InjectForm = (function (_super) {
    tslib_1.__extends(InjectForm, _super);
    function InjectForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(InjectForm.prototype, "tag", {
        get: function () {
            return 'inject';
        },
        enumerable: true,
        configurable: true
    });
    InjectForm.prototype.cast = function (item) {
        if (item.tag === this.tag) {
            var directive_1 = new InjectDirective();
            item.forEach(function (item) {
                this.materializeDirectiveParam(directive_1, item);
            }, this);
            return directive_1;
        }
        return undefined;
    };
    InjectForm.prototype.materializeDirectiveParam = function (directive, item) {
        if (item instanceof Attr && item.key.value === this.tag && item.value instanceof Selector) {
            directive._selector = item.value;
        }
        else if (item instanceof Field) {
            directive._bindings.push(item);
        }
    };
    InjectForm.Form = new InjectForm();
    return InjectForm;
}(DirectiveForm));
export { InjectForm };
DirectiveForm.addGlobal(InjectForm.Form);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5qZWN0LWZvcm0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmplY3QtZm9ybS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxFQUFPLElBQUksRUFBRSxLQUFLLEVBQUUsUUFBUSxFQUFDLE1BQU0sYUFBYSxDQUFDO0FBQ3hELE9BQU8sRUFBQyxhQUFhLEVBQUMsTUFBTSxrQkFBa0IsQ0FBQztBQUMvQyxPQUFPLEVBQUMsZUFBZSxFQUFDLE1BQU0sb0JBQW9CLENBQUM7QUFHbkQ7SUFBZ0Msc0NBQThCO0lBQTlEOztJQXlCQSxDQUFDO0lBeEJDLHNCQUFJLDJCQUFHO2FBQVA7WUFDRSxNQUFNLENBQUMsUUFBUSxDQUFDO1FBQ2xCLENBQUM7OztPQUFBO0lBRUQseUJBQUksR0FBSixVQUFLLElBQVU7UUFDYixFQUFFLENBQUMsQ0FBQyxJQUFJLENBQUMsR0FBRyxLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDO1lBQzFCLElBQU0sV0FBUyxHQUFHLElBQUksZUFBZSxFQUFFLENBQUM7WUFDeEMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxVQUFVLElBQVU7Z0JBQy9CLElBQUksQ0FBQyx5QkFBeUIsQ0FBQyxXQUFTLEVBQUUsSUFBSSxDQUFDLENBQUM7WUFDbEQsQ0FBQyxFQUFFLElBQUksQ0FBQyxDQUFDO1lBQ1QsTUFBTSxDQUFDLFdBQVMsQ0FBQztRQUNuQixDQUFDO1FBQ0QsTUFBTSxDQUFDLFNBQVMsQ0FBQztJQUNuQixDQUFDO0lBRUQsOENBQXlCLEdBQXpCLFVBQTBCLFNBQTBCLEVBQUUsSUFBVTtRQUM5RCxFQUFFLENBQUMsQ0FBQyxJQUFJLFlBQVksSUFBSSxJQUFJLElBQUksQ0FBQyxHQUFHLENBQUMsS0FBSyxLQUFLLElBQUksQ0FBQyxHQUFHLElBQUksSUFBSSxDQUFDLEtBQUssWUFBWSxRQUFRLENBQUMsQ0FBQyxDQUFDO1lBQzFGLFNBQVMsQ0FBQyxTQUFTLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQztRQUNuQyxDQUFDO1FBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDLElBQUksWUFBWSxLQUFLLENBQUMsQ0FBQyxDQUFDO1lBQ2pDLFNBQVMsQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO1FBQ2pDLENBQUM7SUFDSCxDQUFDO0lBRWUsZUFBSSxHQUFHLElBQUksVUFBVSxFQUFFLENBQUM7SUFDMUMsaUJBQUM7Q0FBQSxBQXpCRCxDQUFnQyxhQUFhLEdBeUI1QztTQXpCWSxVQUFVO0FBMEJ2QixhQUFhLENBQUMsU0FBUyxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsQ0FBQyJ9